// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_bs-0";